import { render } from "./ListaEncuestasCompletas.vue?vue&type=template&id=53c087f7"
import script from "./ListaEncuestasCompletas.vue?vue&type=script&lang=js"
export * from "./ListaEncuestasCompletas.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__